import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const Logo = ({ size = 'md', variant = 'default', linked = false, className = '' }) => {
  const { language, theme } = useApp();
  const isLight = theme === 'light';

  const name = language === 'ur' ? 'شایری اسٹوڈیو' : language === 'hi' ? 'शायरी स्टूडियो' : 'ShayariStudio';
  const sub  = language === 'ur' ? 'شاعری کا گھر'  : language === 'hi' ? 'कविता का घर'    : language === 'es' ? 'El Hogar de la Poesía' : language === 'fr' ? 'La Maison de la Poésie' : 'Poetry Hub';

  const sizeMap = {
    sm: { icon: '1.2rem', main: '.88rem',  sub: '.62rem', gap: '.4rem'  },
    md: { icon: '1.8rem', main: '1.15rem', sub: '.7rem',  gap: '.6rem'  },
    lg: { icon: '2.6rem', main: '1.5rem',  sub: '.85rem', gap: '.75rem' },
    xl: { icon: '3.5rem', main: '2rem',    sub: '1rem',   gap: '1rem'   },
  };

  // Resolve colours based on variant AND theme
  const resolveColors = () => {
    if (variant === 'white') {
      // white variant on dark bg = white; on light bg = dark text
      return isLight
        ? { main: '#1a1a2e', sub: '#44446a' }
        : { main: '#ffffff', sub: 'rgba(255,255,255,.75)' };
    }
    if (variant === 'gold') {
      return isLight
        ? { main: '#b8860b', sub: '#8a6a00' }   // dark gold visible on white
        : { main: '#f0d060', sub: 'rgba(240,208,96,.65)' };
    }
    // default
    return isLight
      ? { main: '#2d1a6e', sub: '#6b5b95' }     // deep purple visible on light
      : { main: '#f0d060', sub: 'rgba(240,208,96,.65)' };
  };

  const c = resolveColors();
  const s = sizeMap[size] || sizeMap.md;

  const moonColor = isLight && variant === 'default' ? '#c9a227' : '#e8c96a';

  const content = (
    <span
      className={`logo-wrap ${className}`}
      style={{ display: 'inline-flex', alignItems: 'center', gap: s.gap, textDecoration: 'none' }}
    >
      {/* Moon SVG */}
      <span style={{ fontSize: s.icon, lineHeight: 1, display: 'flex', alignItems: 'center',
        filter: isLight ? 'drop-shadow(0 0 4px rgba(200,160,0,.4))' : 'drop-shadow(0 0 8px rgba(232,201,106,.6))' }}>
        <svg viewBox="0 0 64 64" width={s.icon} height={s.icon} xmlns="http://www.w3.org/2000/svg">
          <path d="M42 32c0 9.4-7.6 17-17 17-2.6 0-5-.6-7.2-1.7C21.4 49.5 26.5 52 32 52c11 0 20-9 20-20S43 12 32 12c-5.5 0-10.6 2.5-14.2 6.7C20 17.6 22.4 17 25 17c9.4 0 17 7.6 17 15z" fill={moonColor}/>
          <circle cx="18" cy="18" r="2"   fill={moonColor} opacity="0.6"/>
          <circle cx="48" cy="46" r="1.5" fill={moonColor} opacity="0.5"/>
          <circle cx="14" cy="44" r="1.2" fill={moonColor} opacity="0.4"/>
        </svg>
      </span>

      {/* Text */}
      <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
        <span style={{
          fontFamily: "'Noto Sans Devanagari','Inter',sans-serif",
          fontWeight: 800,
          fontSize: s.main,
          color: c.main,
          letterSpacing: '.01em',
        }}>
          {name}
        </span>
        <span style={{
          fontSize: s.sub,
          color: c.sub,
          letterSpacing: '.1em',
          textTransform: 'uppercase',
          fontWeight: 500,
          marginTop: '2px',
        }}>
          {sub}
        </span>
      </span>
    </span>
  );

  return linked
    ? <Link to="/" style={{ textDecoration: 'none' }}>{content}</Link>
    : content;
};

export default Logo;
